/**
 * Registry for the page's smooth scroller (Lenis on the homepage hero).
 * Anything that scrolls programmatically asks here first, so it does not
 * fight the smooth scroller. With nothing registered, callers use native scroll.
 */
export type SmoothScroller = {
  scrollTo: (
    target: number | HTMLElement,
    options?: { offset?: number; immediate?: boolean },
  ) => void;
};

let activeScroller: SmoothScroller | null = null;

export const setSmoothScroller = (scroller: SmoothScroller | null) => {
  activeScroller = scroller;
};

export const getSmoothScroller = () => activeScroller;
